import httpClient from '@api/httpClient'
import queryClient from '@api/queryClient'
import type { PaginatedResponse } from '@models/pagination'
import type {
  BulkAcceptOrderRequestData,
  Order,
  OrderExport,
  OrderFilters,
  OrderFromErpFilters,
  OrderFromTmsFilters,
} from '@models/order'
import { ordersKeys, ordersUrls } from './constants'

const getOrdersExport = async (
  filters: Omit<OrderFilters, 'page' | 'limit'>,
): Promise<OrderExport[]> => {
  const { data } = await httpClient.get<OrderExport[]>(
    ordersUrls.ordersExport,
    {
      params: filters,
    },
  )

  return data
}

const getOrders = async (filters: OrderFilters) => {
  const { data } = await httpClient.get<PaginatedResponse<Order>>(
    ordersUrls.orders(),
    {
      params: filters,
    },
  )

  for (const order of data.data) {
    queryClient.setQueryData(ordersKeys.order(order.id), order)
  }

  return data
}

const getErpOrders = async (filters: OrderFromErpFilters) => {
  const { data } = await httpClient.get<PaginatedResponse<Order>>(
    ordersUrls.erpOrders,
    {
      params: filters,
    },
  )

  return data
}

const getTmsOrders = async (filters: OrderFromTmsFilters) => {
  const { data } = await httpClient.get<PaginatedResponse<Order>>(
    ordersUrls.tmsOrders,
    {
      params: filters,
    },
  )

  return data
}

const getOrder = async (id: number) => {
  const { data } = await httpClient.get<Order>(ordersUrls.order(id))
  return data
}

const getOrderGoodsDeliveryNote = async (id: number) => {
  const { data } = await httpClient.get<string>(
    ordersUrls.orderGoodsDeliveryNote(id),
  )
  return data
}

const getOrderPackagingReturnReport = async (id: number) => {
  const { data } = await httpClient.get<string>(
    ordersUrls.orderPackagingReturnReport(id),
  )
  return data
}

const cancelOrder = (orderId: number) =>
  httpClient.post(ordersUrls.cancelOrder(orderId))

const bulkAcceptOrder = (requestData: BulkAcceptOrderRequestData) =>
  httpClient.post(ordersUrls.bulkAcceptOrder, requestData)

const finishStop = (stopId: number) =>
  httpClient.post(ordersUrls.finishStop, {
    stopId,
  })

export default {
  getOrders,
  getOrdersExport,
  getOrder,
  getErpOrders,
  getTmsOrders,
  cancelOrder,
  getOrderGoodsDeliveryNote,
  getOrderPackagingReturnReport,
  bulkAcceptOrder,
  finishStop,
}
